import React, { useEffect } from 'react';
import { Container, Button, CardContainer} from './styles';
import Card from '../Card';
function Cards() {

    const src = (Display,name) => {
        return `../../images/${Display}/${name}.jpg`
    }

    
  return (
    <Container>
        <h1>OUR CREATIONS</h1>
        <CardContainer>
          <Card text = "DEEP EARTH" ImgSourceDesk = {src("desktop","image-deep-earth")} ImgSource={src("mobile","image-deep-earth")}/>
          <Card text = "NIGHT ARCADE" ImgSourceDesk = {src("desktop","image-night-arcade")}  ImgSource={src("mobile","image-night-arcade")} />
          <Card text = "SOCCER TEAM VR" ImgSourceDesk = {src("desktop","image-soccer-team")}  ImgSource={src("mobile","image-soccer-team")}/>
          <Card text = "THE GRID" ImgSourceDesk = {src("desktop","image-grid")}  ImgSource={src("mobile","image-grid")}/>
          <Card text = "FROM UP ABOVE VR" ImgSourceDesk = {src("desktop","image-from-above")}  ImgSource={src("mobile","image-from-above")}/>
          <Card text = "POCKET BOREALIS" ImgSourceDesk = {src("desktop","image-pocket-borealis")} ImgSource={src("mobile","image-pocket-borealis")}/>
          <Card text = "THE CURIOSITY" ImgSourceDesk = {src("desktop","image-curiosity")}  ImgSource={src("mobile","image-curiosity")} />
          <Card text = "MAKE IT FISHEYE" ImgSourceDesk = {src("desktop","image-fisheye")}  ImgSource={src("mobile","image-fisheye")}/>
        </CardContainer>
        <Button placeholder='SEE ALL' value = "SEE ALL">SEE ALL</Button>
    </Container>
  );
}

export default Cards;